import { wfetch } from "../../utils/fetch";
import { getApiEndpoint } from "../../utils/constants/api";

export const FETCH_SITE = "FETCH_SITE";

/**
 * Fetches site info from Magnolia (includes i18n settings).
 * @param {string} nodePath - The node path to get site info for.
 * @returns {Promise<object|null>} The site info JSON or null on error.
 */
export const fetchSite = (nodePath) => {
    return async (dispatch) => {
        const response = await wfetch(getApiEndpoint("SITE_INFO", { pathParams: { path: nodePath } }));

        if (!response) return;

        dispatch({
            type: FETCH_SITE,
            payload: response.data,
        });
    };
};
